module.exports = __webpack_public_path__ + "img/all.3515ecb4.png";